import { styled } from 'styled-components';
import Dashboard from './Components/Dashboard';
import SuasEtapas from './Components/Etapas';
import ImgBackground from '../../assets/intoo_E.png';

const Home: React.FC = () => {
  return (
    <DivBackground>
      <Dashboard />
      <SuasEtapas />
    </DivBackground>
  );
};

const DivBackground = styled.div`
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${ImgBackground});
  background-repeat: no-repeat;
  background-position: top right;
  background-attachment: fixed;
  min-height: 90vh;
`;

export default Home;
